module.exports = {
	"ha": "nha",
	"id": 5.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 59.09090909090909,
						"dataLabels": {
							"enabled": true,
							"format": "13",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": true,
							"format": "10",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": true,
							"format": "10",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40.909090909090914,
						"dataLabels": {
							"enabled": true,
							"format": "9",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 36.36363636363637,
						"dataLabels": {
							"enabled": true,
							"format": "8",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.16129032258065,
						"dataLabels": {
							"enabled": true,
							"format": "59",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.19354838709677,
						"dataLabels": {
							"enabled": true,
							"format": "46",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.35483870967742,
						"dataLabels": {
							"enabled": true,
							"format": "43",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.451612903225815,
						"dataLabels": {
							"enabled": true,
							"format": "35",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 35.483870967741936,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.71794871794873,
						"dataLabels": {
							"enabled": true,
							"format": "77",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": true,
							"format": "66",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 37.17948717948718,
						"dataLabels": {
							"enabled": true,
							"format": "29",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "143",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": true,
							"format": "126",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76,
						"dataLabels": {
							"enabled": true,
							"format": "114",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72,
						"dataLabels": {
							"enabled": true,
							"format": "108",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52,
						"dataLabels": {
							"enabled": true,
							"format": "78",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -40.90909090909091,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -23.076923076923073,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.8387096774193505,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.033898305084744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.521739130434778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.6046511627907,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -37.142857142857146,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.2820512820512775,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -49.122807017543856,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.666666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.888111888111885,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.77777777777778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=22"
			},
			{
				"x": 9,
				"text": "30–39<br>n=62"
			},
			{
				"x": 15,
				"text": "40–49<br>n=78"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=150"
			}
		],
		"dataTable": {
			"< 30": [
				22,
				13,
				10,
				10,
				9,
				8
			],
			"30–39": [
				62,
				59,
				46,
				43,
				35,
				22
			],
			"40–49": [
				78,
				77,
				66,
				60,
				57,
				29
			],
			"≥ 50": [
				150,
				143,
				126,
				114,
				108,
				78
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_3.json
// module id = 265
// module chunks = 0